import { t } from 'i18n';
import React, { useState } from 'react';
import { useNewsFeed } from 'hooks';
import { Loading } from 'components/Loading';
import { styled, Container, Pagination, Grid } from '@teko/ui';
import { NotFound } from '@teko/ecommerce/mobile';
import { NewsCard } from 'modules/news/shared/NewsCard';
import { NewsFeedProps } from '../types';
import { HeadSection } from 'components/HeadSection';
import { Breadcrumbs } from '@teko/ds-desktop';

export const NewsFeed = ({
  news: ssrNews,
  totalItems: ssrTotalItems,
}: NewsFeedProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { news, totalItems, loading } = useNewsFeed({
    ssrNews,
    ssrTotalItems,
    page: currentPage,
  });

  const emptyNews = !news?.length;

  return (
    <>
      <HeadSection title={t('Tin tức')} />

      <Loading isLoading={currentPage !== 1 && loading}>
        <StyledContainer marginTop={16} marginBottom={16}>
          <Breadcrumbs
            breadcrumbs={[
              {
                link: '/',
                name: t('Trang chủ'),
              },
              {
                disabled: true,
                link: '#',
                name: t('Tin tức'),
              },
            ]}
          />
          {emptyNews ? (
            <NotFound text={t('Không tìm thấy bài đăng')} />
          ) : (
            <FeedWrapper>
              <Grid colNum={3} margin={'1rem'}>
                {news.map((feed) => (
                  <CardWrapper key={feed.id}>
                    <NewsCard feed={feed} />
                  </CardWrapper>
                ))}
              </Grid>
              <StyledPagination
                totalRecords={totalItems || 0}
                pageLimit={15}
                onPageChanged={(pageNum: number): void =>
                  setCurrentPage(pageNum)
                }
                currentPage={currentPage}
              />
            </FeedWrapper>
          )}
        </StyledContainer>
      </Loading>
    </>
  );
};
const StyledContainer = styled(Container)`
  min-height: 70vh;
`;
const FeedWrapper = styled.div`
  background-color: #fff;
  border-radius: 4px;
  padding: 0.25rem;
  padding-bottom: 0.75rem;
  min-height: 65vh;
`;
const StyledPagination = styled(Pagination)`
  > ul {
    margin: 0 auto;
  }
  width: 100%;
`;
const CardWrapper = styled.div`
  padding: 0.75rem;
  height: 100%;
`;
